const notificationPreferencesUpdatedEvent =
  "stockerra:notification-preferences-updated"

export function notifyNotificationPreferencesUpdated(): void {
  window.dispatchEvent(new Event(notificationPreferencesUpdatedEvent))
}

export function onNotificationPreferencesUpdated(
  listener: () => void,
): () => void {
  window.addEventListener(notificationPreferencesUpdatedEvent, listener)
  return () =>
    window.removeEventListener(notificationPreferencesUpdatedEvent, listener)
}
